module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "container hidden-xs hidden-sm",
    attrs: {
      "id": "accessibility-nav",
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _c('ul', {
    staticClass: "list pull-right"
  }, [_c('li', [_c('router-link', {
    staticClass: "sr-only-focusable",
    attrs: {
      "to": "#conteudo",
      "title": "Ir para o conteúdo principal"
    }
  }, [_c('span', [_c('small', [_vm._v("Ir para o conteúdo principal")])])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Sitemap'
      },
      "title": "Ir para o mapa do site"
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  })])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Contato'
      },
      "title": "Ir para a página de contato"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 1)])]), _c('hr', {
    staticClass: "-normal",
    attrs: {
      "id": "divisor"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "title pull-left",
    attrs: {
      "href": "http://ufrn.br",
      "target": "_blank",
      "noopener": "noopener"
    }
  }, [_c('h1', {
    attrs: {
      "title": "Ir para ufrn.br"
    }
  }, [_vm._v("UFRN")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b709f9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/AccessibilityNav.vue
// module id = 460
// module chunks = 0